"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccountPlanDetailsSchema = void 0;
const lingo2_models_1 = require("lingo2-models");
const zod_1 = require("zod");
exports.AccountPlanDetailsSchema = zod_1.z.object({
  /** Код процессора платёжной системы */
  billing_processor: zod_1.z.string(),
  /** Идентификатор заказа из платёжной системы */
  billing_order_id: zod_1.z.string().uuid().or(zod_1.z.number()),
  /** Код валюты для проведения платежей */
  billing_currency_id: zod_1.z.nativeEnum(lingo2_models_1.CurrencyEnum),
  /** Идентификатор карты (аккаунта) для оплаты */
  billing_account_id: zod_1.z.string().uuid().or(zod_1.z.number()),
  /** Идентификатор чарджа продления тарифа */
  billing_prolong_charge_id: zod_1.z.string().or(zod_1.z.null())
});
